const handleConsultSaver = (state = {}, action) => {
    switch (action.type) {
      case 'SET_CONSTSAVER':
        return state  = action.data;
      default:
        return state;
    }
  };
  
  export default handleConsultSaver;